import * as React from 'react'
import { InteractiveGraphControllerContext } from '../../../InteractiveGraphControllerProvider';
import { GraphNode } from '../../../models/GraphNode.interface';
import NodeInputFieldGData from '../../../../general/NodeInputFieldGData';
import { ISimpleNode } from '../../../../node/nav/ISimpleNode';


export type Props = {
    className?: string,
    inputClassName?: string,
    variant?: 'plain' | 'outlined',
}

const FindNodeInput: React.FC<Props> = ({variant="outlined", className='', inputClassName=''}: Props) => {
    const graphController = React.useContext(InteractiveGraphControllerContext);
    const [source, setSource] = React.useState<ISimpleNode | GraphNode>(null);

    async function setNode(node: ISimpleNode | GraphNode) {
        if (!node) {
            graphController.selectNode(undefined);

        } else {
            const n = node as GraphNode;
            graphController.selectNode(n.id);
            graphController.zoomTo(n.x, n.y, 1000);
        }
    }

    React.useEffect(() => {
        if (graphController.selectedNode) {
            setSource(graphController.selectedNode);
        } else {
            setSource(undefined);
        }

    }, [graphController.selectedNode]);

    return (
        <div className={className}>
            <div className="" >
                <NodeInputFieldGData value={source as ISimpleNode} label=""
                variant={variant}
                    onChange={node => setNode(node)}
                    datasource={'GData'}
                ></NodeInputFieldGData>
            </div>
        </div>
    );
}

export default FindNodeInput;



